import axios from "axios";
import env from "../config/keys";
// Cria a referencia da API com a base validando ambiente.
const api = axios.create({
  baseURL: env.REACT_APP_BASE_URL,
});
// Retorna objeto de chamadas ja com uma url de base.
export default api;
